import React from 'react';
import styled from 'styled-components';
import squareLogomark from '@99designs/frontend-components/core/images/99designs-byVP-squarelogomark.svg';

const StyledSquareLogomark = styled.div`
    display: inline-block;
    text-align: center;
    width: 70px;
    height: 70px;
`;

export function SquareLogomark() {
    return (
        <StyledSquareLogomark
            dangerouslySetInnerHTML={{
                __html: squareLogomark,
            }}
            aria-label={__('99designs by Vistaprint')}
        />
    );
}
